<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Resultado ISF"
            description="Indicador Sintético Final"
            :enabledModalInformacao="true"
            :textModalInformacao="text"
            url="/indicadores-aps"
          />
        </div>
        <div class="col-lg-4 mb-3">
          <label for="" class="mb-0">Previsão</label>
          <vue-select
            :options="optionsPrevisao"
            label="label"
            placeholder="Previsão"
            @input="onChangePrevisao"
            v-model="previsao"
            class="my-2"
            style="background-color: #fff"
            :clearable="false"
          >
            <template slot="option" slot-scope="option">
              {{ option.label }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="col-lg-4 mb-3">
          <label for="" class="mb-0">Definitivo</label>
          <vue-select
            :options="optionsDefinitivo"
            label="quadrimestre"
            placeholder="Definitivo"
            @input="onChangeDefinitivo"
            v-model="definitivo"
            class="my-2"
            style="background-color: #fff"
            :clearable="false"
          >
            <template slot="option" slot-scope="option">
              {{ option.quadrimestre }}
            </template>
            <div slot="no-options">Não há opções correspondentes</div>
          </vue-select>
        </div>
        <div class="col-lg-12">
          <div class="sh-ri-info">
            <h3>{{ info.title }}</h3>
            <div class="sh-ri-percent" v-if="info.type == 'pre-natal'">
              <div class="sh-ri-percent-red"><span></span> < 18%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 18% e < 31%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 31% e < 45%
              </div>
              <div class="sh-ri-percent-blue"><span></span> >= 45%</div>
            </div>
            <div
              class="sh-ri-percent"
              v-if="
                info.type == 'hiv-sifilis' ||
                info.type == 'consultas-odontologicas'
              "
            >
              <div class="sh-ri-percent-red"><span></span> < 24%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 24% e < 42%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 42% e < 60%
              </div>
              <div class="sh-ri-percent-blue"><span></span> >= 60%</div>
            </div>
            <div class="sh-ri-percent" v-if="info.type == 'citopatologico'">
              <div class="sh-ri-percent-red"><span></span> < 16%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 16% e < 28%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 28% e < 40%
              </div>
              <div class="sh-ri-percent-blue"><span></span> >= 40%</div>
            </div>
            <div class="sh-ri-percent" v-if="info.type == 'polio-penta'">
              <div class="sh-ri-percent-red"><span></span> < 38%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 38% e < 67%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 67% e < 95%
              </div>
              <div class="sh-ri-percent-blue"><span></span> >= 95%</div>
            </div>
            <div
              class="sh-ri-percent"
              v-if="
                info.type == 'hipertensao' || info.type == 'hemoglobina-glicada'
              "
            >
              <div class="sh-ri-percent-red"><span></span> < 20%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 20% e < 35%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 35% e < 50%
              </div>
              <div class="sh-ri-percent-blue"><span></span> >= 50%</div>
            </div>
            <div class="sh-ri-percent" v-if="info.type == 'isf'">
              <div class="sh-ri-percent-red"><span></span> < 4.0</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 4.0 e < 7.0
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 7.0 e <= 9.0
              </div>
              <div class="sh-ri-percent-blue"><span></span> > 9.0</div>
            </div>
            <div class="sh-ri-percent" v-if="info.type == 'desempenho'">
              <div class="sh-ri-percent-red"><span></span> < 40%</div>
              <div class="sh-ri-percent-orange">
                <span></span> >= 40% e < 70%
              </div>
              <div class="sh-ri-percent-green">
                <span></span> >= 70% e <= 90%
              </div>
              <div class="sh-ri-percent-blue"><span></span> > 90%</div>
            </div>
          </div>
        </div>
        <div class="col-lg-12">
          <div class="box" style="margin-top: 10px">
            <table class="table table-responsive table-striped" id="table">
              <thead class="thead-light">
                <tr>
                  <th @mouseover="updateInfo('pre-natal')">
                    Pré-Natal (6 consultas)
                  </th>
                  <th @mouseover="updateInfo('hiv-sifilis')">
                    Pré-Natal (Sífilis e HIV)
                  </th>
                  <th @mouseover="updateInfo('consultas-odontologicas')">
                    Gestantes (Saúde Bucal)
                  </th>
                  <th @mouseover="updateInfo('citopatologico')">
                    Cobertura Citopatológico
                  </th>
                  <th @mouseover="updateInfo('polio-penta')">
                    Cobertura Pólio e Penta
                  </th>
                  <th @mouseover="updateInfo('hipertensao')">
                    Hipertensão (PA Aferida)
                  </th>
                  <th @mouseover="updateInfo('hemoglobina-glicada')">
                    Diabetes (Hemoglobina Glicada)
                  </th>
                  <th @mouseover="updateInfo('isf')">ISF</th>
                  <th @mouseover="updateInfo('quadrimestre')">Quadrimestre</th>
                  <th @mouseover="updateInfo('resultado')">Resultado</th>
                  <th>Fonte</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in resultados" :key="index">
                  <td
                    v-bind:class="
                      indicadorColor(item.pn_6_consultas, 'pre-natal')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.pn_6_consultas }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(item.pn_hiv_sifilis, 'hiv-sifilis')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.pn_hiv_sifilis }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(
                        item.pn_odontologia,
                        'consultas-odontologicas'
                      )
                    "
                    class="font-weight-bold"
                  >
                    {{ item.pn_odontologia }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(item.citopatologico, 'citopatologico')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.citopatologico }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(item.crianca_polio_penta, 'polio-penta')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.crianca_polio_penta }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(item.pa_hipertensao, 'hipertensao')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.pa_hipertensao }}%
                  </td>
                  <td
                    v-bind:class="
                      indicadorColor(item.hg_diabetes, 'hemoglobina-glicada')
                    "
                    class="font-weight-bold"
                  >
                    {{ item.hg_diabetes }}%
                  </td>
                  <td
                    v-bind:class="changeFontColor(parseFloat(item.isf))"
                    class="font-weight-bold"
                  >
                    {{ item.isf }}
                  </td>
                  <td class="font-weight-bold">
                    <!-- {{verificaQuadrimestre()}} -->
                    {{ item.quadrimestre }}
                  </td>
                  <td class="font-weight-bold">
                    {{ item.resultado }}
                  </td>
                  <td class="font-weight-bold">
                    {{ item.fonte }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-12">
          <div style="margin-top: 10px">
            <div class="grafico">
              <div class="grafico-col col-lg-12 p-0">
                <div class="box">
                  <div class="box-header">
                    <h4 class="box-title">
                      <i class="icofont-chart-bar-graph"></i>
                    </h4>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-lg-6">
                        <apexchart
                          id="chartData"
                          type="bar"
                          height="350"
                          :options="chartBarOptions"
                          :series="chartData"
                          ref="chartData"
                        ></apexchart>
                      </div>
                      <div class="mb-4 col-lg-6 flex-column">
                        <div class="row">
                          <div class="col-lg-6">
                            <apexchart
                              id="chartDataPrevisao"
                              type="radialBar"
                              height="200"
                              :options="chartRadialOptionsPrevisao"
                              :series="chartDataPrevisao"
                              ref="chartDataPrevisao"
                            ></apexchart>
                          </div>
                          <div
                            class="c-text-preliminar c-labels flex-column col-lg-6 d-flex align-items-center justify-content-center"
                          >
                            <p>{{ previsaoQuadrimestre }}</p>
                            <p>Previsão</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-6">
                            <apexchart
                              id="chartDataDefinitivo"
                              type="radialBar"
                              height="200"
                              :options="chartRadialOptionsDefinitivo"
                              :series="chartDataDefinitivo"
                              ref="chartDataDefinitivo"
                            ></apexchart>
                          </div>
                          <div
                            class="c-text-definitivo c-labels flex-column col-lg-6 d-flex align-items-center justify-content-center"
                          >
                            <p>{{ definitivoQuadrimestre }}</p>
                            <p>Definitivo</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import VueApexCharts from 'vue-apexcharts'

import {
  chartBarOptions,
  chartRadialOptionsDefinitivo,
  chartRadialOptionsPrevisao,
  infoHtml,
} from './utils.js'

export default {
  name: 'ResultadoIsfAcs',
  metaInfo: {
    title: 'Resultado ISF',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    apexchart: VueApexCharts,
  },
  data() {
    return {
      indicadores: [],
      equipes: [],
      equipe: '',
      recurso: 0,
      textoRecurso: '',
      valorEquipe: 0,
      isISF: true,
      info: {
        type: 'pre-natal',
        title:
          'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a primeira até a 20ª semana de gestação',
      },
      definitivo: '',
      preliminar: {
        pn_6_consultas: '',
        pn_hiv_sifilis: '',
        pn_odontologia: '',
        citopatologico: '',
        crianca_polio_penta: '',
        pa_hipertensao: '',
        hg_diabetes: '',
      },
      resultados: [],
      chartBarOptions: {
        ...chartBarOptions,
      },
      chartRadialOptionsDefinitivo: {
        ...chartRadialOptionsDefinitivo,
      },
      chartRadialOptionsPrevisao: {
        ...chartRadialOptionsPrevisao,
      },
      chartData: [],
      chartDataDefinitivo: [],
      chartDataPrevisao: [],
      definitivoQuadrimestre: '',
      previsaoQuadrimestre: '',
      optionsPrevisao: [],
      previsao: '',
      optionsDefinitivo: [],
      definitivo: '',
      text: infoHtml,
    }
  },
  created() {
    this.init()
  },

  methods: {
    chartBar() {
      this.chartDataDefinitivo = []
      this.chartDataPrevisao = []
      this.chartData = []

      const definitivo = this.resultados.find(
        (element) => element.resultado === 'Definitivo'
      )
      this.definitivoQuadrimestre = definitivo.quadrimestre
      const previsao = this.resultados.find(
        (element) => element.resultado === 'Previsão'
      )
      this.previsaoQuadrimestre = previsao.quadrimestre
      const valueDefinitivo = [
        parseInt(definitivo.pn_6_consultas),
        parseInt(definitivo.pn_hiv_sifilis),
        parseInt(definitivo.pn_odontologia),
        parseInt(definitivo.citopatologico),
        parseInt(definitivo.crianca_polio_penta),
        parseInt(definitivo.pa_hipertensao),
        parseInt(definitivo.hg_diabetes),
      ]

      const valuePrevisao = [
        parseInt(previsao.pn_6_consultas),
        parseInt(previsao.pn_hiv_sifilis),
        parseInt(previsao.pn_odontologia),
        parseInt(previsao.citopatologico),
        parseInt(previsao.crianca_polio_penta),
        parseInt(previsao.pa_hipertensao),
        parseInt(previsao.hg_diabetes),
      ]
      this.chartData.push(
        {
          name: `Definitivo ${this.definitivoQuadrimestre}`,
          data: valueDefinitivo,
        },
        {
          name: `Previsão ${this.previsaoQuadrimestre}`,
          data: valuePrevisao,
        }
      )
      this.chartDataDefinitivo.push(parseFloat(definitivo.isf * 10))

      this.chartDataPrevisao.push(parseFloat(previsao.isf * 10))

      const array_xaxis = [
        'Pré-natal',
        'HIV Sífilis',
        'Odonto',
        'Citológico',
        'Vacinas',
        'Hipertensão',
        'Diabetes',
      ]
      this.$refs.chartData.updateOptions({
        xaxis: {
          categories: array_xaxis,
        },
      })
      this.$refs.chartDataDefinitivo.updateOptions({
        labels: ['ISF'],
      })
      this.$refs.chartDataPrevisao.updateOptions({
        labels: ['ISF'],
      })
    },
    updateInfo(info) {
      switch (info) {
        case 'pre-natal':
          this.info.type = 'pre-natal'
          this.info.title =
            'Proporção de gestantes com pelo menos 6 (seis) consultas pré-natal realizadas, sendo a 1ª (primeira) até a 12ª (décima segunda) semana de gestação.'
          break
        case 'hiv-sifilis':
          this.info.type = 'hiv-sifilis'
          this.info.title =
            'Proporção de gestantes com realização de exames para sífilis e HIV.'
          break
        case 'consultas-odontologicas':
          this.info.type = 'consultas-odontologicas'
          this.info.title =
            'Proporção de gestantes com atendimento odontológico realizado.'
          break
        case 'citopatologico':
          this.info.type = 'citopatologico'
          this.info.title =
            'Proporção de mulheres com coleta de citopatológico na APS.'
          break
        case 'polio-penta':
          this.info.type = 'polio-penta'
          this.info.title =
            'Proporção de crianças de 1 (um) ano de idade vacinadas na APS contra Difteria, Tétano, Coqueluche, Hepatite B, infecções causadas por haemophilus influenzae tipo b e Poliomielite inativada.'
          break
        case 'hipertensao':
          this.info.type = 'hipertensao'
          this.info.title =
            'Proporção de pessoas com hipertensão, com consulta e pressão arterial aferida no semestre.'
          break
        case 'hemoglobina-glicada':
          this.info.type = 'hemoglobina-glicada'
          this.info.title =
            'Proporção de pessoas com diabetes, com consulta e hemoglobina glicada solicitada no semestre.'
          break
        case 'isf':
          this.info.type = 'isf'
          this.info.title = 'Indicador Sintético Final.'
          break
        case 'desempenho':
          this.info.type = 'desempenho'
          this.info.title = 'Desempenho em porcentagem.'
          break
        default:
          break
      }
    },

    changeFontColor(isf) {
      if (isf < 4) {
        return 'sh-re-button-isf-red'
      } else if (isf >= 4 && isf < 7) {
        return 'sh-re-button-isf-orange'
      } else if (isf >= 7 && isf <= 9) {
        return 'sh-re-button-isf-green'
      } else if (isf > 9) {
        return 'sh-re-button-isf-blue'
      } else {
        return ''
      }
    },

    indicadorColor(percentual, indicador) {
      switch (indicador) {
        case 'pre-natal':
          if (percentual < 18) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 18 && percentual < 31) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 31 && percentual < 45) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hiv-sifilis':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'consultas-odontologicas':
          if (percentual < 24) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 24 && percentual < 42) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 42 && percentual < 60) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'citopatologico':
          if (percentual < 16) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 16 && percentual < 28) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 28 && percentual < 40) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'polio-penta':
          if (percentual < 38) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 38 && percentual < 67) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 67 && percentual < 95) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hipertensao':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        case 'hemoglobina-glicada':
          if (percentual < 20) {
            return 'sh-ri-percent-red'
          } else if (percentual >= 20 && percentual < 35) {
            return 'sh-ri-percent-orange'
          } else if (percentual >= 35 && percentual < 50) {
            return 'sh-ri-percent-green'
          } else {
            return 'sh-ri-percent-blue'
          }
          break
        default:
          break
      }
    },

    buscarResultados() {
      this.$api
        .get(
          '/app/resultado-isf/preliminar/municipio/' +
            this.$store.state.cod_ibge +
            '/' +
            this.previsao.value.replace('/', '-') +
            '/' +
            this.definitivo.quadrimestre
        )
        .then((response) => {
          this.resultados = response.data
          this.chartBar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangePrevisao(item) {
      console.log(item, this.definitivo)
      this.$api
        .get(
          '/app/resultado-isf/preliminar/municipio/' +
            this.$store.state.cod_ibge +
            '/' +
            item.value.replace('/', '-') +
            '/' +
            this.definitivo.quadrimestre
        )
        .then((response) => {
          this.resultados = response.data
          this.chartBar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeDefinitivo(item) {
      this.$api
        .get(
          '/app/resultado-isf/preliminar/municipio/' +
            this.$store.state.cod_ibge +
            '/' +
            this.previsao.value.replace('/', '-') +
            '/' +
            item.quadrimestre
        )
        .then((response) => {
          this.resultados = response.data
          this.chartBar()
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async buscarDadosSelect() {
      try {
        const response = await this.$api.get(
          '/app/desempenho-por-equipe/' +
            this.$store.state.cod_ibge +
            '/periodos'
        )
        if (response) {
          this.optionsPrevisao = response.data.map((item) => {
            return {
              label: item.periodo,
              value: item.periodo,
            }
          })
          this.previsao = this.optionsPrevisao[0]
        }
        // quadrimestres
        const quadrimestres = await this.$apiPublic.get(
          '/serie-historica/indicadores-previne-brasil/quadrimestres'
        )
        if (quadrimestres) {
          this.optionsDefinitivo = quadrimestres.data
          this.definitivo = {
            quadrimestre: quadrimestres.data[0].quadrimestre,
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    verificaQuadrimestre() {
      let quadrimestre_atual = ''
      let data_atual = new Date()
      let mes_atual = parseInt(data_atual.getMonth() + 1) // janeiro=0
      let ano_atual = parseInt(data_atual.getFullYear())
      if (mes_atual >= 1 && mes_atual <= 4) {
        quadrimestre_atual = ano_atual + ' Q1'
      } else if (mes_atual >= 5 && mes_atual <= 8) {
        quadrimestre_atual = ano_atual + ' Q2'
      } else if (mes_atual >= 9 && mes_atual <= 12) {
        quadrimestre_atual = ano_atual + ' Q3'
      } else {
        quadrimestre_atual = ''
      }
      return quadrimestre_atual
    },

    async init() {
      await this.buscarDadosSelect()
      await this.buscarResultados()
    },
  },
}
</script>

<style>
.sh-ri-info {
  background-color: #fff;
  padding: 15px;
  margin-bottom: 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.sh-ri-info h3 {
  font-size: 17px;
}

.sh-ri-percent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
}

.sh-ri-percent > div {
  margin: 0 10px;
}

.sh-ri-percent > div:first-child {
  margin-left: 0;
}

.sh-ri-percent span {
  width: 25px;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 4px;
}

.sh-ri-percent-red span {
  background-color: red;
}

.sh-ri-percent-orange span {
  background-color: orange;
}

.sh-ri-percent-green span {
  background-color: green;
}

.sh-ri-percent-blue span {
  background-color: blue;
}

.sh-re-button-isf {
  padding: 0 10px;
  cursor: pointer;
  font-weight: 700;
}

.sh-ri-percent-red,
.sh-re-button-isf-red {
  color: red;
}

.sh-ri-percent-orange,
.sh-re-button-isf-orange {
  color: orange;
}

.sh-ri-percent-green,
.sh-re-button-isf-green {
  color: green;
}

.sh-ri-percent-blue,
.sh-re-button-isf-blue {
  color: blue;
}

.sh-ri .table .thead-light th,
.sh-ri .table tbody td {
  text-align: center;
}

.sh-ri table thead th:hover {
  cursor: pointer;
  background-color: #ccc;
}

.sh-ri table tbody tr td {
  font-size: 14px !important;
}

.sh-ri table tbody tr td .placement {
  margin-right: 15px;
  font-weight: 700;
  display: inline-block;
}

.sh-ri .btn.btn-default {
  color: #333;
  background-color: #ebebeb;
  border-color: #adadad;
  box-shadow: inset 0 3px 5px rgb(0 0 0 / 13%);
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: normal;
  line-height: 1.428571429;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0px;
  height: 38px;
}
</style>
<style scoped>
.c-labels p {
  font-weight: bold;
  margin-bottom: 0px !important;
}

.c-text-definitivo {
  margin-bottom: 34px;
}

@media screen and (max-width: 991px) {
  .c-text-preliminar {
    margin-bottom: 34px;
  }
}
</style>
